module.exports = __webpack_public_path__ + "static/media/save-water.aa90c334.svg";